<template>
  <kst-table action input-mode :data="userAddresses">
    <b-table-column cell-class="ks-col-client-userAddress" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-Name"
      field="Name"
      :label="ClientAddressCatalog.Name.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-Address"
      field="Address"
      :label="ClientAddressCatalog.Address.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-ContactName"
      field="ContactName"
      :label="ClientAddressCatalog.ContactName.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-ContactMobile"
      field="ContactMobile"
      :label="ClientAddressCatalog.ContactMobile.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-ContactPhone"
      field="ContactPhone"
      :label="ClientAddressCatalog.ContactPhone.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-client-edit-ContactEmail"
      field="ContactEmail"
      :label="ClientAddressCatalog.ContactEmail.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.ClientAddress.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userAddresses" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import Info from "../ClientInfo.js";
import Model from "../ClientModel.js";
import ClientAddressCatalog from "../ClientAddressCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userAddresses: Array
  },
  data: () => ({
    Model: Model,
    ClientAddressCatalog: ClientAddressCatalog,
    selectedIndex: null
  }),
  methods: {
    handleRowDelete(index) {
      this.selectedIndex = index;
      this.showConfirm(
        Info.Message.New_ConfirmDeleteAddress,
        this.handleRowDelete_Confirm,
        this.handleRowDelete_Cancel
      );
    },
    handleRowDelete_Confirm() {
      this.userAddresses.splice(this.selectedIndex, 1);
      this.selectedIndex = null;
    },
    handleRowDelete_Cancel() {
      this.selectedIndex = null;
    },
    handleRowErrors(errors, field, index) {
      Model.setAddressErrors(this.userAddresses[index], field, errors);
    }
  }
}
</script>